import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface PlaceCardSkeletonProps {
  compact?: boolean;
}

export const PlaceCardSkeleton = ({ compact = false }: PlaceCardSkeletonProps) => {
  return (
    <div className={cn(
      "flex items-center gap-3 p-3 rounded-xl bg-card border border-border/30"
    )}>
      {/* Image skeleton */}
      <Skeleton className={cn(
        "flex-shrink-0 rounded-xl",
        compact ? "w-14 h-14" : "w-16 h-16"
      )} />
      
      {/* Content */}
      <div className="flex-1 space-y-2">
        {/* Title */}
        <Skeleton className={cn("h-4", compact ? "w-28" : "w-36")} />
        {/* Distance/Address */}
        <Skeleton className="h-3 w-20" />
        {/* Badges */}
        <div className="flex gap-1.5">
          <Skeleton className="h-5 w-14 rounded-full" />
          <Skeleton className="h-5 w-12 rounded-full" />
        </div>
      </div>
    </div>
  );
};
